import script from "./BookingMethod.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingMethod.vue?vue&type=script&lang=ts&setup=true"

import "./BookingMethod.vue?vue&type=style&index=0&id=08cfcda9&lang=scss&scoped=true"
import "./BookingMethod.vue?vue&type=style&index=1&id=08cfcda9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08cfcda9"]])

export default __exports__